export const SELECT_ALL = 'ResolutionCenter/AffMailboxesDetail/SELECT_ALL'
export const UNSELECT_ALL = 'ResolutionCenter/AffMailboxesDetail/UNSELECT_ALL'
